var exports = {
  "k": "xe564cbfb--e6d6be--container",
};

module.exports = exports;
